<template>
  <ui-modal-layout :title="tr('Ouch...')" :icon="FrownIcon" tone="destructive">
    <p class="m-0">
      {{ textPart1 }}
      {{ textPart2 }}
    </p>

    <template #footer>
      <ui-button @click="() => $fullscreenModal.closeAll()">
        {{ tr('Close') }}
      </ui-button>
    </template>
  </ui-modal-layout>
</template>

<script>
import { Frown } from '@lucide/vue';
import { markRaw } from 'vue';

export default {
  name: 'HasNoAssetsModalContent',
  props: {
    asset: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    FrownIcon: markRaw(Frown),
  }),
  computed: {
    textPart1() {
      switch (this.asset) {
        case 'ad-account':
          return this.tr('The connected Facebook profile does not have an available advertising account.');

        case 'source-profile':
          return this.tr('The connected Facebook profile does not have an available Facebook Page.');
      }

      return '';
    },
    textPart2() {
      return this.tr('In the absence of this, unfortunately, you won\'t be able to use the :app.');
    },
  },
};
</script>
